//Style
import styles from "../../styles/Form-Inputs.module.css"

//primereact
import { MultiSelect } from "primereact/multiselect"
import { Skeleton } from "primereact/skeleton"

//Formik
import { useField } from "formik"

export default function FormikMultiSelectInput({
  name,
  label,
  isInitialLoad,
  onChangeCallBack,
  options,
  optionGroupLabel,
  optionGroupChildren,
  optionGroupTemplate,
  optionLabel,
  optionValue,
  placeHolderValue,
  helpText,
  itemTemplate,
  disableFormikSubmit, //Does not submit changes to formik. Can be used in conjunction with onChangeCallBack for manual processing
  disabled,
  required,
  displayType,
  maxSelectedLabels,
}) {
  const [field, meta, helpers] = useField(name)

  const getSelect = () => {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <>
          <MultiSelect
            value={field.value}
            options={options}
            onChange={(e) => {
              if (!disableFormikSubmit) {
                helpers.setValue(e.value)
              }
              if (!!onChangeCallBack) {
                onChangeCallBack(e.value)
              }
            }}
            optionGroupLabel={optionGroupLabel}
            optionGroupChildren={optionGroupChildren}
            optionGroupTemplate={optionGroupTemplate}
            optionLabel={optionLabel}
            optionValue={optionValue}
            placeholder={
              !placeHolderValue ? `Please select an entry` : placeHolderValue
            }
            display={displayType || "chip"}
            filter
            className={meta.touched && meta.error ? "p-invalid" : undefined}
            itemTemplate={!!itemTemplate ? itemTemplate : null}
            disabled={disabled}
            style={{ width: "100%" }}
            maxSelectedLabels={maxSelectedLabels}
          />
          {meta.touched && meta.error ? (
            <label id={`${name}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
          ) : null}
        </>
      )
    }
  }

  return (
    <div
      className={`${styles.field} ${
        disabled ? "formikMultiSelectInputDisabled" : "formikMultiSelectInput"
      }`}
    >
      <label>
        {label} {required ? <span style={{ color: "red" }}> * </span> : null}
      </label>
      <div>
        {helpText ? (
          <div style={{ marginBottom: "10px" }}>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
        {getSelect()}
      </div>
    </div>
  )
}
